import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import Icon from '../../components/icons';
import { useStoreSelector, useAuthStatus, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { useReviewRatingApi } from '../../store/api/hooks/reviewratingApiHook';
import toast from 'react-hot-toast';
import { Paginator } from 'primereact/paginator';
import moment from 'moment';
import Spinner from '../../components/iconSvgs/spinner';
import { ReviewListProps } from '../../_config/interfaces/interfaces';
import { showDate } from '../../_common/functions';


const ReviewList: React.FC<ReviewListProps> = ({ filterValue }) => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [reviewData, setReviewData] = useState<any>({});
    const [first, setFirst] = useState(1);
    const [perPage, setPerpage] = useState(10);
    const [page, setPage] = useState(1);
    const [isPagination, setIsPagination] = useState<boolean>(false);
    const [totalcount, setTotalCount] = useState(0);

    const branchDS = useStoreBrnDSSelector();
    const reviewAPI = useReviewRatingApi();

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue);
        } else {
            getReviewList({});
        }

    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        getReviewList(filterValue);
    }

    const getReviewList = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = {
                branch_id: branchDS?.branch_id, page: Math.floor(first / perPage) + 1,
                page_size: perPage, ...param
            };
        } else {
            params = {
                'branch_id': branchDS?.branch_id,
                'page': Math.floor(first / perPage) + 1, // Page is 1-based, adjust accordingly
                'page_size': perPage
            };
        }
        try{
            setTimeout(() => {
            reviewAPI.getReviewList(params, (msg: any, resp: any) => {
                setReviewData(resp.data);
                setTotalCount(resp.pagination?.total_records || 0);
                setIsPagination(true);
    
    
            }, (err: any, resp: any) => {
                toast.error(resp?.detail?.message);
            });
            setOnSubmitLoading(false);
        }, 3000);

        }catch(err: any){
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    const handlePageChange = (e: any) => {
        const newPage = e.page;
        const newFirst = e.first;
        const newRows = e.rows;

        if (newFirst !== first || newRows !== perPage) {
            setPage(newPage);
            setPerpage(perPage)
            setFirst(newFirst);

            let params: any;
            if (filterValue) {
                params = {
                    branch_id: branchDS?.branch_id, page: newPage + 1,
                    page_size: perPage, ...filterValue
                };
            } else {
                params = {
                    'branch_id': branchDS?.branch_id,
                    'page': newPage + 1, // Page is 1-based, adjust accordingly
                    'page_size': perPage
                };
            }
            getReviewList(params);
        }
    };

    return (
        <div className="flex flex-col">
            <div className="flex justify-between items-center mb-4 bg-gray-200 p-2 rounded-md">
                <h1 className="text-base font-semibold text-gray-600">
                    Review Listing
                </h1>
                {/* <button className="text-lg text-gray-500 font-semibold bg-white py-2 px-4 rounded-md hover:bg-white transition-all duration-300">
                    Export
                </button> */}
            </div>

            <div className="mt-4">
                <div>
                    {Object.entries(reviewData).length > 0 ? (
                        Object.entries(reviewData).map(([date, reviews], index) => (
                            <div key={index}>
                                <div className="text-lg font-medium text-gray-400">
                                    {moment(date).format('YYYY-MM-DD')}
                                </div>
                                <hr className="mb-2" />
                                <div>
                                    {(reviews as any[]).map((review: any, idx: number) => {
                                        let sentimentClass = '';
                                        if (review.sentiment === 'positive') {
                                          review.sentimentClass = 'bg-green-400';
                                        } else if (review.sentiment === 'negative') {
                                            review.sentimentClass = 'bg-red-400';
                                        } else if (review.sentiment === 'mixed') {
                                            review.sentimentClass = 'bg-yellow-400';
                                        } else {
                                            review.sentimentClass = 'bg-gray-400';
                                        }
                                        return (
                                        <div key={review.feedback_id} className="mb-3">
                                            <div className="flex flex-col sm:flex-row sm:space-x-8 mb-3">

                                                <div className="flex flex-col sm:w-2/3">
                                                    <div className="flex items-center">
                                                        {[...Array(review.feedback_rating)].map((_, idx) => (
                                                            <span key={idx} className="text-yellow-500">
                                                                <Icon name="full-star" size={22} className="text-yellow-500" />
                                                            </span>
                                                        ))}
                                                        {[...Array(5 - review.feedback_rating)].map((_, idx) => (
                                                            <span key={idx} className="text-yellow-500">
                                                                <Icon name="star" size={22} className="text-yellow-500" />
                                                            </span>
                                                        ))}
                                                    </div>

                                                    <p className="mt-2 text-sm text-gray-700">{review.review_text}</p>

                                                    {/* <div className="mt-2 text-sm text-gray-500 capitalize">
                                                        {review.sentiment}
                                                    </div> */}
                                                </div>

                                                <div className="flex flex-col sm:w-1/3 text-sm text-gray-700 mt-2 sm:mt-0 rounded-lg shadow-md bg-white p-4">
                                                    <div className="text-sm font-semibold text-gray-700 mb-2">{review.customer_name}</div>


                                                    <div className="text-sm text-gray-500 mb-2">{showDate(date, 'YYYY-MM-DD')}</div>

                                                    {review.keywords?.length > 0 && (
                                                        <div className="mt-1 mb-1">
                                                            <div className="font-semibold text-gray-700">Keywords:</div>
                                                            <div className="flex flex-wrap">
                                                                {review.keywords.map((keyword: string, index: number) => (
                                                                    <span key={index} className="bg-gray-200 text-gray-700 font-medium p-1 rounded-md text-xs mr-2 mb-2 inline-block">
                                                                        {keyword}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {review.topics?.length > 0 && (
                                                        <div className="mt-1 mb-1">
                                                            <div className="font-semibold text-gray-700">Topics:</div>
                                                            <div className="flex flex-wrap">
                                                                {review.topics.map((topic: string, index: number) => (
                                                                    <span key={index} className="bg-gray-200 text-gray-700 font-medium p-1 rounded-md text-xs mr-2 mb-2 inline-block">
                                                                        {topic}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="flex flex-wrap">
                                                    <span key={index} className={`bg-gray-200 text-gray-800 font-medium p-2 rounded-md text-sm mr-2 mb-2 inline-block ${review?.sentimentClass} capitalize`}>
                                                    {review.sentiment}
                                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        )
                                    })}
                                    {/* ))} */}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div>No reviews found</div>
                    )}
                </div>

                {/* Pagination */}
                {isPagination && totalcount > 10 && (
                    <div className="mt-4">
                        <Paginator
                            first={first}
                            rows={perPage}
                            totalRecords={totalcount}
                            onPageChange={handlePageChange}
                            className="p-jc-center"
                        />
                    </div>
                )}
            </div>

        </div>
    );
};

export default ReviewList;